import { computed, inject, Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { Icons } from '@atoms/icon/icon.component';

const CURRENT_NEWS_VERSION = 3;
export const NEWS = {
  availableFeatures: [
    {
      nameKey: 'shared.dialogs.news.features.webinarManagement.name',
      descriptionKey: 'shared.dialogs.news.features.webinarManagement.description',
      icon: Icons.WEBINARS,
      badgeKey: 'shared.dialogs.news.features.webinarManagement.badge',
    },
    {
      nameKey: 'shared.dialogs.news.features.paidWebinars.name',
      descriptionKey: 'shared.dialogs.news.features.paidWebinars.description',
      icon: Icons.MONETIZATION,
      badgeKey: 'shared.dialogs.news.features.paidWebinars.badge',
    },
    {
      nameKey: 'shared.dialogs.news.features.webinarTemplates.name',
      descriptionKey: 'shared.dialogs.news.features.webinarTemplates.description',
      icon: Icons.CUSTOMIZED,
      badgeKey: 'shared.dialogs.news.features.webinarTemplates.badge',
    },
    {
      nameKey: 'shared.dialogs.news.features.recordingManagement.name',
      descriptionKey: 'shared.dialogs.news.features.recordingManagement.description',
      icon: Icons.RECORDING,
      badgeKey: 'shared.dialogs.news.features.recordingManagement.badge',
    },
  ],
  comingSoonFeatures: [
    {
      nameKey: 'shared.dialogs.news.features.participantManagement.name',
      descriptionKey: 'shared.dialogs.news.features.participantManagement.description',
      icon: Icons.PARTICIPANTS,
      badgeKey: 'shared.dialogs.news.features.participantManagement.badge',
    },
    {
      nameKey: 'shared.dialogs.news.features.webinarAnalytics.name',
      descriptionKey: 'shared.dialogs.news.features.webinarAnalytics.description',
      icon: Icons.STATISTICS,
      badgeKey: 'shared.dialogs.news.features.webinarAnalytics.badge',
    },
  ],
};

@Injectable()
export class EduNewsService {
  private localStorage = inject(LocalStorageService);

  private acknowledgedNewsVersion = this.localStorage.storageSignal('acknowledgedNewsVersion', 0);

  public isNewsVisible = computed(() => {
    return this.acknowledgedNewsVersion() < CURRENT_NEWS_VERSION;
  });

  public acknowledgeNews() {
    this.acknowledgedNewsVersion.set(CURRENT_NEWS_VERSION);
  }
}
